import $ from 'jquery';

const FileTracking = () => {
    $(document).ready(function () {
        if (typeof fileTrackingData !== 'undefined') {
            fileTrackingData.forEach(function (item, index) {
                const linkElement = $(`a[href="${item.file.url}"]`);
                if (linkElement.length) {
                    linkElement.one('click contextmenu', function (e) {
                        trackClick(item.file.ID);
                    });

                    linkElement.on('keydown', function (e) {
                        if (e.key === 'Enter' || e.keyCode === 13) {
                            trackClick(item.file.ID);
                        }
                    });
                }
            });
        }
    });
};

const trackClick = (fileID) => {
    $.ajax({
        url: `/wp/wp-admin/admin-ajax.php?timestamp=${new Date().getTime()}`,
        type: 'POST',
        data: {
            action: 'update_file_clicks',
            file_id: fileID,
            nonce: updateClicksNonce
        }
    });
};

export default FileTracking;
